var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c("div", { staticClass: "wrapper" }, [
        _c("div", { staticClass: "pop-up-map" }, [
          _c(
            "div",
            { staticClass: "pop-up__close", on: { click: _vm.closeWindow } },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/img/svg/close.svg"),
                  alt: "close",
                },
              }),
            ]
          ),
          _c(
            "div",
            { staticClass: "map" },
            [
              _c("base-map", {
                attrs: {
                  id: _vm.id,
                  "location-map": _vm.locationMap,
                  "circle-list": _vm.circleList,
                },
                on: { setPoint: _vm.setPoint, moveMarker: _vm.moveMarker },
              }),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }